import { APP_ROUTES } from "@/constants/routes";
import { cn } from "@/lib/utils";
import { Category } from "@/models/category";
import { User } from "@/models/user";
import { Box } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { ChevronDownIcon } from "lucide-react";
import { useTranslations } from "next-intl";
import { useEffect, useRef, useState } from "react";
import MenuCategory from "./MenuCategory";
interface NavBarProps {
  user?: User | null;
  locale?: string;
}
const NavBar = ({ user, locale }: NavBarProps) => {
  const t = useTranslations("messages");
  const queryClient = useQueryClient();
  const categories =
    queryClient.getQueryData<Category[]>([
      "categories-wp",
      {
        language: locale,
      },
    ]) || [];
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const closeTimerRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (closeTimerRef.current) {
        window.clearTimeout(closeTimerRef.current);
        closeTimerRef.current = null;
      }
    };
  }, []);

  const cancelCloseTimer = () => {
    if (closeTimerRef.current) {
      window.clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  };

  const startCloseTimer = () => {
    cancelCloseTimer();
    closeTimerRef.current = window.setTimeout(() => {
      setAnchorEl(null);
      closeTimerRef.current = null;
    }, 150);
  };

  const handlePopoverClose = () => {
    cancelCloseTimer();
    setAnchorEl(null);
  };

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    cancelCloseTimer();
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);

  return (
    <Box className="md:flex lg:gap-9 md:gap-4 md:mr-2 items-center boxItemRigth text-ciBlue_900 hidden">
      {/* <div className="text-center hidden md:flex">
        <a
          className="no-underline !text-[0.9rem] !font-bold textMobile cursor-pointer text-cimigo-blue hover:!text-cimigo-green"
          href={APP_ROUTES.HOME.to}
          translation-key="common_home"
        >
          {t("common_home")}
        </a>
      </div>
      <div className="text-center hidden md:flex">
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="no-underline !text-[0.9rem] !font-bold textMobile cursor-pointer text-cimigo-blue hover:!text-cimigo-green"
          href={"https://cimigo.com"}
          translation-key="common_trends"
        >
          {t("common_trends")}
        </a>
      </div> */}
      <div
        className={cn("text-center hidden md:flex h-full", {
          "!hidden": categories?.length === 0,
        })}
      >
        <p
          className={cn(
            "group border-none h-full flex items-center gap-1 bg-transparent !text-[0.9rem] m-0 !font-bold textMobile cursor-pointer text-cimigo-blue hover:!text-cimigo-green",
            {
              "!text-cimigo-green": open,
            }
          )}
          translation-key="common_resources"
          aria-owns={open ? "mouse-over-popover" : undefined}
          aria-haspopup="true"
          onMouseEnter={handlePopoverOpen}
          // onMouseLeave={startCloseTimer}
        >
          {t("common_resources")}
          <ChevronDownIcon
            size={16}
            className={cn(
              "transform transition-transform duration-200 ease-in-out",
              {
                "rotate-180": open,
              }
            )}
          />
        </p>
        <MenuCategory
          anchorEl={anchorEl}
          open={open}
          handlePopoverClose={handlePopoverClose}
          cancelCloseTimer={cancelCloseTimer}
          startCloseTimer={startCloseTimer}
          locale={locale}
        />
      </div>
      {user?.license && !user?.license?.isOutOfDate ? null : (
        <div className="text-center hidden md:flex">
          <a
            className="no-underline !text-[0.9rem] !font-bold textMobile cursor-pointer text-cimigo-blue hover:!text-cimigo-green"
            href={APP_ROUTES(locale as any).PRICING.to}
            translation-key="common_pricing"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("common_pricing")}
          </a>
        </div>
      )}
      <div className={cn("text-center hidden md:flex")}>
        <a
          className="no-underline !text-[0.9rem] !font-bold textMobile cursor-pointer text-cimigo-blue hover:!text-cimigo-green"
          href={APP_ROUTES(locale as any).FAQ.to}
          translation-key="common_FAQ"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("common_FAQ")}
        </a>
      </div>
    </Box>
  );
};

export default NavBar;
